import dayjs from 'dayjs';
import type { Chat, ChatMessage } from './type';
import type { Message } from '~/apollo/generated';
import { decodeNodeId, encodeNodeId } from '~/apollo/utils/filters';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapToChat = (r: any): Chat => {
  const careerServiceUserId = encodeNodeId(r.career_service_user_id);
  const careerServiceChatId = encodeNodeId(r.career_service_chat_id);
  return {
    id: r.id,
    userId: r.user_id,
    careerServiceUserId,
    careerServiceChatId,
    chatStatus: r.chat_status,
    isDeclined: r.is_declined,
    isFavorite: r.is_favorite,
    lastPostedAt: r.last_posted_at,
    lastMessage: r.last_message,
    organizationName: r.organization_name,
    organizationLogoImageUrl: r.organization_logo_image_url,
    relatedJobPosting: undefined
  };
};

export const mapToChatMessage = (chat: Chat, message: Message): ChatMessage => {
  const createdAt = dayjs((message.createdAt || 0) * 1000).format('YYYY/MM/DD');

  // 自分が送信したメッセージを判別するための処理です。
  // decodeされたsenderIdには、careerServiceUserIdが含まれているかどうかで判別します。
  const userNodeId = decodeNodeId(chat.careerServiceUserId);
  const senderNodeId = decodeNodeId(message.senderId ?? '');
  const isSelf = senderNodeId.includes(userNodeId);

  return {
    body: message.body ?? '',
    createdAt,
    name: chat.organizationName,
    avatarImageUrl: chat.organizationLogoImageUrl,
    isSelf,
    attachment: message.attachment ?? ''
  };
};
